import FindSubscribers from './FindSubscribers/FindSubscribers';
import SubscriptionList from './SubscriptionList/SubscriptionList';
import styles from './Subscriptions.module.css';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { setAppTitle } from '../../../redux/slices/appSlice';
import type { SubscriberModel } from 'redux/services/api.generated';
import ScreenReaderOnly from '@standardsdigital/ui-components/ScreenReaderOnly';
import { useTranslation } from 'react-i18next';

function Subscriptions() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [selectedSubscriber, setSelectedSubscriber] = useState<
    SubscriberModel | undefined
  >();

  useEffect(() => {
    dispatch(setAppTitle({}));
  }, [dispatch]);

  return (
    <section className={styles.pageWrapper}>
      <ScreenReaderOnly>
        <h1>{t('subscriptions.subscriptions')}</h1>
      </ScreenReaderOnly>
      <FindSubscribers
        setSelectedSubscriber={setSelectedSubscriber}
        selectedSubscriber={selectedSubscriber}
        className={styles.findSubscribers}
      />
      <SubscriptionList selectedSubscriber={selectedSubscriber} />
    </section>
  );
}

export default Subscriptions;
